<ng-container *ngIf="releases$ | async as releases">
  <p *ngIf="releases.length === 0" class="release-notes__empty">
    {{ 'releaseNotes.empty' | translate }}
  </p>

  <section *ngFor="let release of releases" class="release-notes__release">
    <header class="release-notes__release-header">
      <span class="release-notes__release-title">{{ localized(release.title) }}</span>
      <span class="release-notes__release-date">{{ release.date | appDate: 'mediumDate' }}</span>
    </header>
    <ul class="release-notes__items">
      <li *ngFor="let item of release.items" class="release-notes__item">
        <span class="release-notes__badge" [attr.data-type]="item.type">
          {{ 'releaseNotes.type.' + item.type | translate }}
        </span>
        <span class="release-notes__item-text">{{ localized(item.text) }}</span>
      </li>
    </ul>
  </section>
</ng-container>
